import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { LineOptions } from '../../../utils/models/line-options';
import { customColorSets } from '../../../utils/custom-color-sets';

/**
 * Area normalized chart component
 * @author Prasanth Venkatesan
 */
@Component({
  selector: 'neu-charts-area-normalized',
  template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-area-chart-normalized
        [scheme]="colorScheme"
        [results]="data"
        [legend]="options.showLegend"
        [xAxis]="options.showXAxis"
        [yAxis]="options.showYAxis"
        [showXAxisLabel]="options.showXAxisLabel"
        [showYAxisLabel]="options.showYAxisLabel"
        [xAxisLabel]="options.xAxisLabel"
        [yAxisLabel]="options.yAxisLabel"
        [timeline]="options.timeline"
        (select)="mSelectedEvent($event)">
        <!-- [autoScale]="options.autoScale"
        [roundDomains]="options.roundDomains"> -->
    </ngx-charts-area-chart-normalized>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
  styles: [`.chart-container{width:100%;height:100%}`]
})
export class AreaNormalizedComponent implements OnInit {

    @Input('data') data: any;
    @Input('options') customOptions: LineOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: LineOptions = new LineOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        Object.assign(this.options, this.customOptions);
        if((this.data && (changes.data.previousValue != changes.data.currentValue)) || 
        (this.options.isXAxisDate && (changes.customOptions.previousValue != changes.customOptions.currentValue))) {
            this.data.forEach(element => {
                element.series.forEach(seriesData => {
                    seriesData.name = new Date(seriesData.name);
                });
            });
        }
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
